<template>
  <div class="col-xs-12">
      <div class="container">
          <div class="row">
              <div class="col-xs-12">
                  <h3>صور المنتج</h3>
              </div>
              <div class="col-xs-12 gallery-container" id="lightgallery">
                <photo-item v-for="(image, index) in Images" :key="index" :image="image"></photo-item>      
               
            </div>
             
          </div>
      </div>
       
      
      
              
  </div>
</template>
<script>
import PhotoItem from '@/components/products/photo'
import 'lightgallery/dist/js/lightgallery-all.min.js'
export default {
  name:'Gallery',
  props: ['Images'],
  components:{
      PhotoItem
  },
  mounted(){
    //   $(document).ready(function() {
    //         $("#lightgallery").lightGallery(); 
    // });
  }
}
</script>

<style lang="scss">
     @import 'lightgallery/dist/css/lightgallery.css';


.gallery-container {
    clear: both;
    margin-top: 20px;
    margin-bottom: 30px;
    padding: 0px !important;
    overflow:hidden;
    display: flex;
    flex-wrap: wrap;
	justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/products/gallery.vue